import { BaseApiClient } from './base-client'
import { API_ROUTES, interpolateRoute } from '@super/shared-types'
import type { LmRunLog, ApiOffsetPaginatedResponse } from '@super/shared-types'

export class LmRunLogApiClient extends BaseApiClient {
  async getBySession(
    sessionId: string,
    companyId: string,
    opts: { limit?: number; offset?: number } = {},
  ): Promise<ApiOffsetPaginatedResponse<LmRunLog>> {
    const params = new URLSearchParams({
      sessionId,
      companyId,
      limit: String(opts.limit ?? 50),
      offset: String(opts.offset ?? 0),
    })
    return this.request<ApiOffsetPaginatedResponse<LmRunLog>>(
      `${API_ROUTES.ADMIN.LM_RUN_LOGS.LIST}?${params.toString()}`,
    )
  }

  async getById(id: string, companyId: string): Promise<LmRunLog> {
    const path = interpolateRoute(API_ROUTES.ADMIN.LM_RUN_LOGS.BY_ID, { id })
    return this.request<LmRunLog>(`${path}?companyId=${companyId}`)
  }
}

export const lmRunLogApiClient = new LmRunLogApiClient()
